export const mergeCatalogs = (catalogs) => {
    return catalogs.reduce((acc, catalog, index) => {
        return index === 0 ? catalog : { ...acc, products: [...acc.products, ...catalog.products] };
    }, {});
};
export const mergeTemplates = (templates) => {
    return templates.reduce((acc, template, index) => {
        return index === 0
            ? template
            : { ...acc, templates: [...acc.templates, ...template.templates] };
    }, {});
};
//# sourceMappingURL=mergeCatalogs.js.map